// 选择请假申请单号
import React from 'react'
import { connect } from 'react-redux'
import {
    addListItem, changeListItem, deleteListItem, getListFromValues, getMergedValues,
    hasChangedValues, getFormValue, changeItemsValue, nullDate, getListIds
} from '../../public/utility'
import FlowRecordDetail from '../OAManagement/FlowRecordDetail'
import LeaveApplyDetail from 'tyan/menus/LeaveManageMent/LeaveApplyDetail'
class SelectOutApplyNumberDiv extends React.Component {
    state = {
        leaveNumber: this.props.initValues && this.props.initValues.outApplyNumber || '',
        bReadOnly: this.props.initValues && this.props.initValues.bReadOnly || false ,
    }

    componentDidMount = () => {
        this.doGetOutApplyNumberInfo()
    }

    doGetOutApplyNumberInfo = (searchString = '') => {
        const { relatedPerson } = this.props
        const { leaveNumber, bReadOnly } = this.state
        Tyan.doPostEvent('GetOutApplyNumberList', {
            data: {
                search: searchString,
                relatedPerson,
                bReadOnly,
                leaveNumber
            },
            onEnd: ({ errorMessage, items请假申请单, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    this.setState({ items请假申请单, initValues基本信息, changedValues基本信息: {} })
                }
            }
        })
    }

    handlerSave = () => {
        const { onConfirm, onClose } = this.props
        const { changedValues基本信息 } = this.state
        let objNewJson = getMergedValues(this, '基本信息')
        const { list } = getListFromValues('请假申请单', objNewJson, {})
        // const { list } = getListFromValues('请假申请单', '', null, changedValues基本信息)
        // if (list.length > 1) {
        //     Tyan.pubForm.showError('只能选一条记录')
        //     return
        // }
        var i = 0
        let number = ''
        for (i = 0; i < list.length; i++) {
            if (i < list.length - 1)
                number = number + list[i].请假单号 + ','
            else
                number = number + list[i].请假单号
        }
        onConfirm && onConfirm(number)
        onClose && onClose()

    }

    handlerGetLeaveApplyDetail = (申请编号,outReason) => {
        console.log('outReason',outReason)
        if (outReason == '外训')
            Tyan.doPostEvent({
                event: 'GetOutTrainDetail',
                data: { 申请编号 },
                onEnd: ({ errorMessage, id }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    Tyan.pubForm.showDialog('外训申请单', props => <FlowRecordDetail {...props} id={id} type={'show'} />)
                }
            })
        else
            Tyan.doPostEvent({
                event: 'GetLeaveApplyDetail',
                data: { 申请编号 },
                onEnd: ({ errorMessage, id }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    Tyan.pubForm.showDialog('请假申请单', props => <LeaveApplyDetail {...props} id={id} notSubmit={true} />)
                }
            })
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    fieldset基本信息 = () => {
        const { items请假申请单 } = this.state
        return [
            {
                _checkgrid: '', name: '请假申请单', rowNumbers: false, minRows: 15, margin: "5px 10px 5px 10px", minWidth: '90%',
                itemsValues: items请假申请单, onSearch: this.doGetOutApplyNumberInfo,
                columns: [
                    { _text: '出差/外训申请单号', name: '请假单号', minWidth: 150, flex: 1 },
                    { _text: '起止时间', name: '请假起止时间', minWidth: 300, flex: 1 },
                    { _text: '原因', name: '请假原因', minWidth: 100, flex: 1 },
                    {
                        _buttons: [
                            {
                                _button: '查看', icon: 'info-circle', ui: '', margin: 0,
                                handler: ({ showDetail, refreshPage }, data) => this.handlerGetLeaveApplyDetail(data.请假单号,data.请假原因),
                                // cdt:() => !onlyView
                            },
                        ], width: 100, margin: 0,
                    },
                ],
            }]
    }

    render() {
        const { showMessage: Message, showBody: Body, bReadOnly, } = this.props
        const { errorMessage, initValues基本信息, changedValues基本信息 } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this} maxWidth="1000"
            controls={
                [
                    { _button: '确定', icon: 'save', handler: this.handlerSave, disabled: !this.bChanged() },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]
            }
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: bReadOnly },
                ]}
        />
    }
}

export default connect()(SelectOutApplyNumberDiv)